import { Component, WritableSignal, signal } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent {

  tbc = toSignal(this.adminService.getCountByStatus('tbc'));
  cfd = toSignal(this.adminService.getCountByStatus('cfd'));
  del = toSignal(this.adminService.getCountByStatus('del'));
  err = toSignal(this.adminService.getCountByStatus('err'));
  tempmodel = toSignal(this.adminService.getTempModel());
  tempref = toSignal(this.adminService.getTempRef());


  constructor(private adminService: AdminService) {

  }
}
